import type { UtmParams } from '../useUtmParams/useUtmParams'

export type UtmProperties = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

export type CampaignContext = {
  source?: string
  medium?: string
  name?: string
  term?: string
  content?: string
}

const withoutEmptyValues = <T extends Record<string, string | null | undefined>>(
  properties: T
): Partial<Record<keyof T, string>> =>
  Object.fromEntries(Object.entries(properties).filter(([, value]) => !!value)) as Partial<Record<keyof T, string>>

export const toUtmProperties = (utmParams: UtmParams | null): UtmProperties =>
  utmParams
    ? withoutEmptyValues({
        utm_source: utmParams.utmSource,
        utm_medium: utmParams.utmMedium,
        utm_campaign: utmParams.utmCampaign,
        utm_term: utmParams.utmTerm,
        utm_content: utmParams.utmContent
      })
    : {}

export const toCampaignContext = (utmParams: UtmParams | null): CampaignContext =>
  utmParams
    ? withoutEmptyValues({
        source: utmParams.utmSource,
        medium: utmParams.utmMedium,
        name: utmParams.utmCampaign,
        term: utmParams.utmTerm,
        content: utmParams.utmContent
      })
    : {}
